import { render, staticRenderFns } from "./ResourcePropertyMap.vue?vue&type=template&id=b93f8f7a"
import script from "./ResourcePropertyMap.vue?vue&type=script&lang=ts"
export * from "./ResourcePropertyMap.vue?vue&type=script&lang=ts"
import style0 from "./ResourcePropertyMap.vue?vue&type=style&index=0&id=b93f8f7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports